import React, { Component, useState } from "react";
import Slider from "rc-slider";
import "./CheckBox.css";
import "rc-slider/assets/index.css";
import { Checkbox } from "primereact/checkbox";
const style = { width: "100%", margin: "auto", paddingLeft: "2%", paddingTop: "2%", flexDirection: "row" };
const labelStyle = { width: "4vw", flex: 1, flexWrap: "wrap", flexDirection: "row" };
const containerStyle = { width: "4vw", flex: 1, flexWrap: "wrap", flexDirection: "row" };
const weekStyle = { position: "absolute", top: -55, left: 20 };

function log(value) {
  //console.log(value); //eslint-disable-line
}

function CheckBoxes(props) {
  return (
    <div className="col-12">
      {props.weeks.map((item, index) => {
        return (
          <div key={index} className="CheckBox">
            {index === 0 ? (
              <div style={{ display: "flex", flexDirection: "column", padding: 0 }}>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginTop: "10px" }}>
                  Voor
                </p>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginBottom: "10px" }}>
                  Plant
                </p>
              </div>
            ) : (
              <></>
            )}
            {index === 1 ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginTop: "10px", color: "rgba(0,0,0,0)" }}>
                  {" "}
                  a
                </p>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginBottom: "10px" }}>
                  Plant
                </p>
              </div>
            ) : (
              <></>
            )}

            {index > 1 ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginTop: "10px" }}>
                  Wk:
                </p>
                <p className="p-checkbox-label" style={{ fontSize: "90%", padding: 0, margin: 0, marginBottom: "10px" }}>
                  {index - 1}
                </p>
              </div>
            ) : (
              <></>
            )}
            <Checkbox
              inputId="cb1"
              disabled={props.disabled}
              value={index}
              checked={props.weeks[index]}
              onChange={(e) => {
                props.weeks[e.value] = !props.weeks[e.value];
                props.setWeeks([...props.weeks]);
              }}
            ></Checkbox>
          </div>
        );
      })}
    </div>
  );
}

export default CheckBoxes;
